import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

export default function AddRoleModal({ onAdd }) {
  const [show, setShow] = useState(false);
  const [roleName, setRoleName] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onAdd(roleName);
    setShow(false);
    setRoleName('');
  };

  return (
    <>
      <Button variant="primary" size="sm" onClick={() => setShow(true)}>
        + Add Role
      </Button>

      <Modal show={show} onHide={() => setShow(false)} centered>
        <Form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Add New Role</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group controlId="roleName">
              <Form.Label>Role Name</Form.Label>
              <Form.Control
                type="text"
                value={roleName}
                onChange={(e) => setRoleName(e.target.value)}
                required
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShow(false)}>
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Add Role
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}
